import React, { useMemo, useState } from 'react';
import { Badge, Form } from 'react-bootstrap';

import {
  filterComprasETableColumnOptions,
  groupedComprasETableColumnOptions,
  toggleComprasETableColumn,
} from './comprasETableColumns';

interface ComprasEColumnPickerProps {
  selected: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

const ComprasEColumnPicker: React.FC<ComprasEColumnPickerProps> = ({
  selected,
  onChange,
  disabled = false,
}) => {
  const [query, setQuery] = useState('');
  const groups = useMemo(
    () => groupedComprasETableColumnOptions(filterComprasETableColumnOptions(query)),
    [query],
  );
  const selectedSet = useMemo(() => new Set(selected), [selected]);
  const lastRemaining = selected.length <= 1;

  return (
    <Form.Group className="mb-3">
      <Form.Label className="small text-muted mb-1">Colunas da tabela</Form.Label>
      <Form.Control
        type="text"
        size="sm"
        className="mb-2"
        value={query}
        disabled={disabled}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Buscar coluna..."
        autoComplete="off"
      />
      <div className="projects-columns-picker">
        {groups.map((group) => {
          const selectedInGroup = group.columns.filter((column) => selectedSet.has(column.id)).length;
          return (
            <div key={group.id} className="projects-columns-group">
              <div className="projects-columns-group-header">
                <div className="fw-semibold small">{group.label}</div>
                <Badge bg="secondary">{selectedInGroup}/{group.columns.length}</Badge>
              </div>
              <div className="small text-muted mb-1">{group.hint}</div>
              {group.columns.map((column) => {
                const checked = selectedSet.has(column.id);
                return (
                  <Form.Check
                    key={column.id}
                    type="checkbox"
                    id={`compras-e-col-${column.id}`}
                    label={column.label}
                    checked={checked}
                    disabled={disabled || (lastRemaining && checked)}
                    onChange={() => onChange(toggleComprasETableColumn(selected, column.id))}
                  />
                );
              })}
            </div>
          );
        })}
        {!groups.length && (
          <div className="small text-muted">Nenhuma coluna encontrada.</div>
        )}
      </div>
    </Form.Group>
  );
};

export default ComprasEColumnPicker;
